<div class="list-item">
  <app-photo
    size="m"
    [rounded]="true"
    [type]="'photo'"
    [id]="user.photoId"
    [text]="user | userDisplayableName: 'short'"
  ></app-photo>

  <div class="list-item__info">
    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01">
        {{ user | userDisplayableName }}
      </span>

      <ng-container *ngIf="birthDateContent">
        <ng-container *ngTemplateOutlet="birthDateContent; context: { $implicit: user.birthDate }"></ng-container>
      </ng-container>
    </div>

    <span class="list-item__text text_size-xs text_color-03 text_truncate">
      {{ user.organisationName }}
    </span>

    <span class="list-item__text text_size-xs text_color-03 text_truncate">
      {{ user.jobTitlesDescription }}
    </span>
  </div>
</div>
